import React from 'react';
import MyCourses from './course/mycourses.js';
import MyForms from './forms/myforms.js';
import MyCoursesThisMonth from './course/mycoursesthismonth.js';
import OrganizationCourses from './course/organizationcourses.js';


export default class Dashboard extends React.Component
{
    constructor(props)
    {
        super(props);
        this.loadRecentAttempts = this.loadRecentAttempts.bind(this);
        this.loadAnnouncements = this.loadAnnouncements.bind(this);
        this.state = {
            loaded: false,
            orgadmin: false,
            announcements: [],
            recentAttempts: [],
            announcementError: ""
        }
    }
    componentDidMount()
    {
        this.loadAnnouncements().then(
            this.loadRecentAttempts()
        ).then(
            this.checkOrgAdmin()
        );
    }
    checkOrgAdmin()
    {
        this.setState({loaded: false});
        this.props.api.send({
            controller: "Dashboard",
            action: "CheckOrgAdmin",
            method: "get",
            success: result => {
                this.setState({
                    loaded: true,
                    orgadmin: result.success
                });
            },
            error: err => {
                this.setState({loaded: true});
            }
        })
    }
    loadAnnouncements()
    {
        return new Promise((resolve, reject) => {
            this.setState({loaded: false});
            this.props.api.send({
                controller: "Dashboard",
                action: "GetAnnouncements",
                method: "get",
                success: (result) =>
                {
                    result.success ? 
                        this.setState({loaded: true, announcementError: "", announcements: result.announcements}, 
                            () => { resolve(); }
                        ) :
                        this.setState({loaded: true, announcementError: result.message }, () => reject())
                },
                error: (err) =>
                {
                    this.setState({loaded: true, announcementError: "Error getting announcements."}, () => reject())
                }
            })    
        })
    }
    loadRecentAttempts()
    {
        return new Promise((resolve, reject) => {
            this.setState({loaded: false});
            this.props.api.send({
                controller: "Dashboard",
                action: "GetRecentTestResults",
                method: "get",
                debug: true,
                success: (result) =>
                {
                    this.setState({loaded: true, recentAttempts: result.success ? result.attempts : []}, () => {
                        resolve();
                    })
                },
                error: (err) =>
                {
                    this.setState({loaded: true, message: "An error occurred while fetching recent attempt results."}, () => {
                        reject();
                    })
                }
            })
        });
    }
    render()
    {
        const announcements = this.state.announcements.map((a) =>
            <div className={a.level === 2 ? "lmscritical" : a.level === 1 ? "lmswarning" : "lmsinfo" } key={a.announcementID}>
                {a.announcementText}
            </div>
        )
        return (
            <div className="lmsdisplayarea">
                <h3>Dashboard</h3>
                {this.state.loaded ? (
                    <div>
                        {this.state.announcements.length > 0 ? (
                            <div>
                                <strong>Announcements</strong>
                            {announcements}
                            </div>
                        ) : null}
                        {this.state.orgadmin ? (
                            <div>
                                <strong>Organization Courses</strong>
                                <OrganizationCourses api={this.props.api} />
                            </div>
                        ) : null}

                        <MyCoursesThisMonth api={this.props.api} />
                            
                        <strong>My Courses</strong>
                        <MyCourses api={this.props.api} />

                        <strong>My Forms</strong>
                        <MyForms api={this.props.api} />
                    </div>
                ) : (
                    <div className="lmscenter">
                        <img src="/images/spinner.svg" alt="Loading..." />
                    </div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/dashboard.js